import { useCoreConfig } from '@alfalab/core-config';
import { useMatchMedia } from './useMatchMedia.js';
import 'react';
import '@alfalab/hooks';
import './utils.js';

function useIsDesktop(breakpoint, defaultValue) {
    var client;
    if (typeof defaultValue === 'boolean') {
        client = defaultValue ? 'desktop' : 'mobile';
    }
    else if (typeof defaultValue === 'function') {
        client = defaultValue() ? 'desktop' : 'mobile';
    }
    var config = useCoreConfig({ breakpoint: breakpoint, client: client });
    var query = "(min-width: ".concat(config.breakpoint, "px)");
    var isDesktop = useMatchMedia(query, config.client === 'desktop')[0];
    return isDesktop;
}

export { useIsDesktop };
